import { useActiveRole, useUser } from '@/contexts/UserSession';
import { UserRole } from '@/gql/enums';

const useReportAbilities = () => {
    const user = useUser(true);
    const activeRole = useActiveRole();
    const role = activeRole?.role || null;
    const company = user.__typename === 'TenantUser' ? user.company : null;

    const canViewReports = () => {
        return user?.__typename === 'TenantUser';
    };

    const canViewListTraineeReports = () => {
        return !!company?.id && [UserRole.Trainer, UserRole.CompanyAdmin, UserRole.CourseAdmin].includes(role!);
    };

    const canEditTrainersNotes = () => {
        return [UserRole.Trainer, UserRole.CompanyAdmin, UserRole.CourseAdmin].includes(role!);
    };

    const displayReportMenuItem = () => {
        return canViewReports() || canViewListTraineeReports();
    };

    return {
        canViewReports,
        displayReportMenuItem,
        canViewListTraineeReports,
        canEditTrainersNotes,
    };
};

export type ReportAbilities = ReturnType<typeof useReportAbilities>;
export default useReportAbilities;
